module.exports = __webpack_public_path__ + "static/media/top-offer-banner2.9f8a4507.jpg";